<template>
  <div id="app">
    <component v-bind:is="layout"></component>
  </div>
</template>

<script>
export default {
  name: "App",
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "",
    // all titles will be injected into this template
    titleTemplate(titleChunk) {
      let appName = process.env.VUE_APP_Name;
      if (process.env.VUE_APP_ENV !== "production") {
        appName += "(" + process.env.VUE_APP_ENV + ")";
      }
      return titleChunk ? `${titleChunk} - ${appName}` : appName;
    }
  },
  computed: {
    // 使用动态组件，达到 布局 的效果。路由定义中使用 meta 元信息 layout 字段指定应用布局
    layout() {
      if (this.$route.meta && this.$route.meta.layout) {
        return this.$route.meta.layout;
      }
      return "default";
    }
  },
  beforeCreate() {
    // 获取 api token
    // this.$store.dispatch("getToken").then(() => {
    //   if (this.$store.state.loginStatus) {
    //     this.$store.dispatch("getUserInfo");
    //   }
    // });
    // 获取产品信息
    this.$store.dispatch("getProducts");
    // 获取 枚举
    this.$store.dispatch("getEnums");
    this.$store.dispatch("getTk_it");
    //获取分类
    // this.$store.dispatch("getCategorys");
  }
};
</script>
